import React, { FC, memo } from 'react';

import { ROUTES_MOB } from '@constants/common/menu.constants';

import Card from '../Card';
import Item from '../Item';
import useStyles from './styles.module';

interface Props {
  onClose: () => void;
}

const Explore: FC<Props> = ({ onClose }: Props) => {
  const { classes } = useStyles();

  return (
    <Card title="Explore">
      <div className={classes.explore}>
        {ROUTES_MOB.map(({ title, href, icon, newTab, isBlueIcon }) => (
          <Item
            key={`menu-${title}`}
            label={title}
            path={href}
            icon={icon}
            newTab={newTab}
            onClose={onClose}
            isBlueIcon={isBlueIcon}
          />
        ))}
      </div>
    </Card>
  );
};

export default memo(Explore);
